import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { getBrandConfig } from './brandConfig';

const brandConfig = getBrandConfig();
const brandTitle = (brandConfig.appTitle || brandConfig.name || 'Discador.NET').replace(/[_-]+/g, ' ');
document.title = `${brandTitle} - IA de Voz`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
